angular.module('pe4h').controller('MessageController', function($scope, $rootScope,AuthService, $state, $q, configuration, Upload, $uibModal ) {

    $scope.init = function(){
    }

    $scope.removeFile = function(){
        $scope.file = undefined;
    }

    $scope.sendMessage = function(){
        var deferred = $q.defer();
        var id = $scope.user.IsClient ? $scope.proposal.Id : $scope.myProposal.Id;
        Upload.upload({
            url: configuration.webApi.proposals.proposals_id_message({id: id}),
            data: {
                    "Message": $scope.message,
                    "Attachment":$scope.file
                },
        })
       .then(
           function (data) {
                deferred.resolve(data);
                var modalSent = $uibModal.open({
                    templateUrl: 'modal-sent.html',
                    size: 'sm',
                    scope: $scope,
                    controller:["$scope", "$uibModalInstance", "$q", function ($scope, $uibModalInstance, $q) {
                        // We could do something in the modal here.
                        $scope.name = $scope.user.IsClient ? $scope.profileData.user.FullName : $scope.client.FullName;
                    }]
                });

                modalSent.closed.then(function (data) {
                    $scope.getMessages();
                });
                //console.log("pases",data);
                $scope.message = "";
                $scope.messageForm.$setPristine();
                $scope.messageForm.$setUntouched();
           },
           function (data) {
               $scope.alertErrorFromServer(data);
               deferred.reject(data);
           },
           //progress callback
           function (evt) {
               deferred.notify({ prog: evt.loaded / evt.total, evt: evt });
           }
       );

        return deferred.promise;
    }
});